import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VideoExercise', LATEST_SCHEMA_VERSION.VideoExercise);
export default exerciseTypeVersionAdapter;